exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".loadingCircle-9e50e{align-items:center;background-color:#b1b0bf;border-radius:5rem;display:flex;height:10rem;justify-content:center;width:10rem}", ""]);

// Exports
exports.locals = {
	"loadingCircle": "loadingCircle-9e50e"
};